import { render, staticRenderFns } from "./global-id-cell.vue?vue&type=template&id=49cddf23&scoped=true"
import script from "./global-id-cell.vue?vue&type=script&lang=ts"
export * from "./global-id-cell.vue?vue&type=script&lang=ts"
import style0 from "./global-id-cell.vue?vue&type=style&index=0&id=49cddf23&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cddf23",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49cddf23')) {
      api.createRecord('49cddf23', component.options)
    } else {
      api.reload('49cddf23', component.options)
    }
    module.hot.accept("./global-id-cell.vue?vue&type=template&id=49cddf23&scoped=true", function () {
      api.rerender('49cddf23', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/budget-requests/accordion-budget-requests/cells/global-id-cell.vue"
export default component.exports